// extracted by mini-css-extract-plugin
module.exports = {"videos":"videos_videos__2mbzo"};